import React, { useState } from "react";
import { Button, Col, Row, Typography } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import AppModalWrapper from "../components/Items/Modal/AppModalWrapper";
import { axiosPost } from "../api/Axios";
import useMultiNotification from "../hooks/useNotification";
import { useAppDispatch } from "../redux-toolkit/store/store";
import { reloadOrdersApi } from "../redux-toolkit/slices/ordersSlice";

const confirmButtonStyle: React.CSSProperties = {
  minWidth: "140px",
  backgroundColor: "#ff4d4f",
  borderColor: "#ff4d4f",
  color: "#fff",
};

interface IRefundConfirmationModal extends GeneralModalProps {
  order: IDashboardOrder;
}

const RefundConfirmationModal: React.FC<IRefundConfirmationModal> = ({
  show,
  handleClose,
  order,
}) => {
  const { contextHolder, openNotification } = useMultiNotification();
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState<boolean>(false);

  const handleRefund = async () => {
    setLoading(true);
    try {
      await axiosPost<{ orderId: string }, any>("/admin/orders/refundOrder", {
        orderId: order._id,
      });
      dispatch(reloadOrdersApi(true));
      openNotification("success", "Success", "Order refunded successfully");
      setTimeout(() => {
        handleClose(true);
        setLoading(false);
      }, 1500);
    } catch (error) {
      setLoading(false);
      if (typeof error === "string") {
        openNotification("error", "Error", error);
      } else {
        openNotification("error", "Error", "Failed to refund order");
      }
    }
  };

  return (
    <>
      <style>
        {`
          .refund-confirm-button-red {
            background-color: #ff4d4f !important;
            border-color: #ff4d4f !important;
            color: #fff !important;
          }
          .refund-confirm-button-red:hover {
            background-color: #ff7875 !important;
            border-color: #ff7875 !important;
          }
          .refund-confirm-button-red:focus {
            background-color: #ff4d4f !important;
            border-color: #ff4d4f !important;
          }
        `}
      </style>
      {contextHolder}
      <AppModalWrapper
        title="Confirm Refund"
        headerStyle={{
          backgroundColor: "#f5f5f5",
          color: "#101828",
          fontSize: "16px",
          fontWeight: "700",
          height: "50px",
        }}
        width={500}
        open={show}
        onCancel={() => {
          handleClose(false);
        }}
      >
        <div style={{ padding: "30px" }}>
          <Row gutter={[16, 24]}>
            <Col span={24}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "20px",
                }}
              >
                <ExclamationCircleOutlined
                  style={{
                    fontSize: "24px",
                    color: "#ff4d4f",
                    marginRight: "12px",
                  }}
                />
                <Typography
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    color: "#101828",
                    margin: 0,
                  }}
                >
                  Are you sure you want to refund this order?
                </Typography>
              </div>
              <div
                style={{
                  backgroundColor: "#f9f9f9",
                  padding: "16px",
                  borderRadius: "8px",
                  marginLeft: "36px",
                }}
              >
                <Typography
                  style={{
                    fontSize: "14px",
                    color: "#666",
                    marginBottom: "8px",
                  }}
                >
                  Order Number:
                </Typography>
                <Typography
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    color: "#101828",
                  }}
                >
                  #{order.processingDetails.orderNumber}
                </Typography>
              </div>
            </Col>
            <Col
              span={24}
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "12px",
                marginTop: "8px",
                paddingTop: "20px",
                borderTop: "1px solid #f0f0f0",
              }}
            >
              <Button
                onClick={() => handleClose(false)}
                disabled={loading}
                size="large"
                style={{ minWidth: "100px" }}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                danger
                onClick={handleRefund}
                loading={loading}
                size="large"
                className="refund-confirm-button-red"
                style={confirmButtonStyle}
              >
                Confirm Refund
              </Button>
            </Col>
          </Row>
        </div>
      </AppModalWrapper>
    </>
  );
};

export default RefundConfirmationModal;
